export { Title2 } from './Title2';
export { title2ClassNames } from './useTitle2Styles.styles';
